"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _DarkSquareButton = _interopRequireDefault(require("./DarkSquareButton.style"));

var DarkSquareBorderButton = function DarkSquareBorderButton(props) {
  var children = props.children;
  return _react.default.createElement(_DarkSquareButton.default, props, children);
};

DarkSquareBorderButton.propTypes = {
  style: _propTypes.default.object,
  onClick: _propTypes.default.func,
  disabled: _propTypes.default.bool,
  type: _propTypes.default.oneOf(['bordered', 'filled']),
  borderType: _propTypes.default.oneOf(['solid', 'dashed']),
  size: _propTypes.default.oneOf(['medium', 'large']),
  status: _propTypes.default.oneOf(['normal', 'danger']),
  active: _propTypes.default.bool
};
DarkSquareBorderButton.defaultProps = {
  style: {},
  onClick: function onClick() {},
  disabled: false,
  type: 'bordered',
  borderType: 'solid',
  size: 'large',
  status: 'normal',
  active: false
};

var _default = (0, _emotionTheming.withTheme)(DarkSquareBorderButton);

exports.default = _default;